module.exports = __webpack_public_path__ + "img/mobile.a1110677.png";